import { Effect, pipe, Option, Record } from "effect";
import { KvClientError, KvService } from "./types";
import { getMarketProtocolKeyMapKey } from "./keys";
import { Schema } from "@effect/schema";
import { MarketChainUidFromString, ProtocolKey } from "@silo/types";
import { MarketChainMap } from "@silo/utils";

export type GetMarketProtocolKeyMap = ReturnType<
  typeof getMarketProtocolKeyMap
>;
export type GetMarketProtocolKeyMapSuccess =
  Effect.Effect.Success<GetMarketProtocolKeyMap>;
export type GetMarketProtocolKeyMapError =
  Effect.Effect.Error<GetMarketProtocolKeyMap>;
export type GetMarketProtocolKeyMapContext =
  Effect.Effect.Context<GetMarketProtocolKeyMap>;

export function getMarketProtocolKeyMap() {
  return Effect.gen(function* () {
    const kv = yield* KvService;
    const result = yield* Effect.tryPromise({
      try: async () => {
        return kv.hgetall(getMarketProtocolKeyMapKey());
      },
      catch: (cause) => new KvClientError({ cause }),
    });

    const markets = yield* pipe(
      result,
      Option.fromNullable,
      Option.map(Record.toEntries),
      Effect.andThen(
        Schema.decodeUnknown(
          Schema.Array(Schema.Tuple(MarketChainUidFromString, ProtocolKey))
        )
      )
    );

    const marketProtocolKeyMap = new MarketChainMap<ProtocolKey>();

    for (const [marketChainUid, protocolKey] of markets) {
      marketProtocolKeyMap.set(marketChainUid, protocolKey);
    }

    return marketProtocolKeyMap;
  });
}
